import React from 'react';

import component, {makePath, navigateTo} from './component';
import {Close} from './icons';

export default component('Attention', function({text, onClose}) {
  return (
    <div className="Attention">
      <span className="Attention-Title">Внимание!</span>
      {text}
      <Close className="Attention-Close" onClick={onClose} />
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/components/Attention.js